/* eslint-disable sort-keys */
const PET_DEMOS_STEPS = {
  WELCOME: 1,
  YOUR_POLICY: 2,
  COMPLETE_PET_DETAILS: 3,
  // 4: pet information modal
  // 5: complete pet details again...
  COMPLETE_PET_REMOVAL: 6,
  INELIGIBLE_PETS: 7,
  AGREEMENTS: 8,
  SUBMIT_FAILURE: 9,
  SUBMIT_SUCCESS: 10,
};

// Maps each step number to its URL hash string.
const STEP_HASH_MAP = {
  [PET_DEMOS_STEPS.WELCOME]: 'pd-welcome',
  [PET_DEMOS_STEPS.YOUR_POLICY]: 'pd-your-policy',
  [PET_DEMOS_STEPS.COMPLETE_PET_DETAILS]: 'pd-complete-pet-details',
  [PET_DEMOS_STEPS.COMPLETE_PET_REMOVAL]: 'pd-pet-removal',
  [PET_DEMOS_STEPS.INELIGIBLE_PETS]: 'pd-ineligible-pets',
  [PET_DEMOS_STEPS.AGREEMENTS]: 'pd-agreements',
  [PET_DEMOS_STEPS.SUBMIT_FAILURE]: 'pd-submit-failure',
  [PET_DEMOS_STEPS.SUBMIT_SUCCESS]: 'pd-submit-success',
};

// Reverse of STEP_HASH_MAP: hash string → step number.
// Used to read the current step from the URL hash on load or back/forward nav.
const HASH_STEP_MAP = Object.fromEntries(
  Object.entries(STEP_HASH_MAP).map(([step, hash]) => [hash, Number(step)]),
);

const CERTIFICATE_LINKING_STEPS = {
  LANDING: 1,
  ALREADY_REGISTERED: 2,
  VERIFY_DETAILS: 3,
  VERIFY_DATE_OF_HIRE: 4,
  SELECT_EMAIL: 5,
  EMAIL_LINKED_SUCCESS: 6,
  CONFIRM_REGISTERED_EMAIL: 7,
  ENTER_AUTHORIZATION_CODE: 8,
  EMAIL_UPDATED_SUCCESS: 9,
};

// URLs for agreement links
const INSURANCE_FRAUD_URL =
  'https://www.petpartners.com/insurance-fraud-warnings';
const ECONSENT_URL =
  'https://www.petpartners.com/res/common/files/electronic_consent_group.pdf';
// eslint-disable-next-line max-len
const DISCLOSURE_URL = 'https://kc-ihc-prod-data.s3.us-east-2.amazonaws.com/static/Disclosure+and+Waiver+Form+V5.pdf';

const PET_DEMOS_KEY_PREFIX = 'pet_demos_state';

export {
  CERTIFICATE_LINKING_STEPS,
  DISCLOSURE_URL,
  ECONSENT_URL,
  HASH_STEP_MAP,
  INSURANCE_FRAUD_URL,
  PET_DEMOS_KEY_PREFIX,
  PET_DEMOS_STEPS,
  STEP_HASH_MAP,
};
